import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTypography } from "../../../components/CustomTypography/CustomTypography";
import { CustomButton } from "../../../components/CustomButton/CustomButton";
import { CustomModal } from "../../../components/CustomModal/CustomModal";
import { useExportMyData, useAnonymizeMyAccount } from "../../../api/gdpr";
import useStyles from "./styles";

export const PrivacyData = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [openConfirm, setOpenConfirm] = useState(false);
  const { mutate: exportData, isPending: exporting } = useExportMyData();
  const { mutate: anonymize, isPending: deleting } = useAnonymizeMyAccount();

  return (
    <div className={classes.divPrivacy}>
      <CustomModal
        open={openConfirm}
        title={t("privacy.deleteAccount", "Delete my account")}
        onClose={() => setOpenConfirm(false)}
        onCancel={() => setOpenConfirm(false)}
        onSave={() => anonymize()}
        loadingSave={deleting}
        labelConfirmation={t("common.delete", "Delete") as string}
      >
        <div className={classes.confirmText}>
          <CustomTypography
            text={t(
              "privacy.deleteAccountWarning",
              "This anonymises your personal data and closes your account. This action is irreversible and you will be signed out immediately."
            )}
            variant="default"
          />
        </div>
      </CustomModal>

      <div className={classes.header}>
        <CustomTypography
          text={t("privacy.title", "My personal data (GDPR)")}
          variant={"h3"}
          isUppercase
        />
      </div>

      <CustomTypography
        text={t(
          "privacy.description",
          "Download a copy of the personal data we hold about you, or permanently delete your account."
        )}
        variant="link"
        styles={{ containerText: classes.description }}
      />

      <div className={classes.actions}>
        <CustomButton
          label={
            exporting
              ? (t("common.loading", "Loading...") as string)
              : (t("privacy.exportData", "Download my data") as string)
          }
          variant={"secondary"}
          height={"40px"}
          width={"fit-content"}
          onClick={() => exportData()}
        />
        <CustomButton
          label={t("privacy.deleteAccount", "Delete my account") as string}
          variant={"primary"}
          height={"40px"}
          width={"fit-content"}
          onClick={() => setOpenConfirm(true)}
        />
      </div>
    </div>
  );
};
